var map = {
	"./1- Dr. R. Sreemamulu -National Standing Counsel Advocate Supreme Coourt of India.jpeg": 46522,
	"./10- Adv. Rajesndra Prasad - Asst.  Counsel Vskp Dist.  AP.jpg": 21423,
	"./2-Adv. S. Sukanya Priya-National Standing Counsel.jpeg": 71398,
	"./3- Prof.K K K Chand-National Standing Counsel.jpeg": 91104,
	"./4-V JYOTHIRMAYE-State Standing Counsel Andhra Pradesh.jpg": 8131,
	"./5-J. Devi Prasad-District Standing Counsel Visakhapatnam.jpeg": 55101,
	"./6- Apalla Raju-District Standing Counsel Visakhapatnam.jpg": 29625,
	"./7- Dr. KVK Chand - DIstrict Standing Counsel Visakhapatnam.jpg": 14985,
	"./8- Adv. J. Srinivas - District Standing Counsel.jpeg": 34255,
	"./9- Adv. P. Ajay Raju - DIstrict Standing Counsel Vskp AP.jpg": 50330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55060;